export default __webpack_public_path__ + "static/media/capaRocombole.459d4240.jpg";